var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5050(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 56,
    viewBox: "0 0 37 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 26,
    width: 4,
    height: 37,
    rx: 2,
    transform: "rotate(90 37 26)",
    fill: "#BFBFBF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_262_2951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10C19.7882 10 21.0236 9.47322 21.9345 8.53553C22.8454 7.59785 23.3571 6.32608 23.3571 5C23.3571 3.67392 22.8454 2.40215 21.9345 1.46447C21.0236 0.526784 19.7882 0 18.5 0C17.2118 0 15.9764 0.526784 15.0655 1.46447C14.1546 2.40215 13.6429 3.67392 13.6429 5C13.6429 6.32608 14.1546 7.59785 15.0655 8.53553C15.9764 9.47322 17.2118 10 18.5 10ZM16.7658 11.875C13.0281 11.875 10 14.9922 10 18.8398C10 19.4805 10.5047 20 11.127 20H25.873C26.4953 20 27 19.4805 27 18.8398C27 14.9922 23.9719 11.875 20.2342 11.875H16.7658Z",
    fill: "#828284"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_262_2951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 46C18.7882 46 20.0236 45.4732 20.9345 44.5355C21.8454 43.5979 22.3571 42.3261 22.3571 41C22.3571 39.6739 21.8454 38.4021 20.9345 37.4645C20.0236 36.5268 18.7882 36 17.5 36C16.2118 36 14.9764 36.5268 14.0655 37.4645C13.1546 38.4021 12.6429 39.6739 12.6429 41C12.6429 42.3261 13.1546 43.5979 14.0655 44.5355C14.9764 45.4732 16.2118 46 17.5 46ZM15.7658 47.875C12.0281 47.875 9 50.9922 9 54.8398C9 55.4805 9.50469 56 10.127 56H24.873C25.4953 56 26 55.4805 26 54.8398C26 50.9922 22.9719 47.875 19.2342 47.875H15.7658Z",
    fill: "#828284"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_2951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "white",
    transform: "translate(10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_262_2951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "white",
    transform: "translate(9 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5050);
export default __webpack_public_path__ + "static/media/50_50.6145b908e97cbcbaeab773f0a103f586.svg";
export { ForwardRef as ReactComponent };